

function fetchFilteredProducts(tags) {
     var tagString = tags;
        var url = '/collections/all/';  
        if (tags.length > 0 && !tags.includes('all')) {
            url += tagString;
        }    
        history.pushState(null, null, url);
    
            $.ajax({
                type: 'GET',
                 url: url,
                success: function(data) {
                     var filter_coll_current = $('#products-grid_item');
                     var filter_coll_final = $(data).find('#products-grid_item');
                     filter_coll_current.replaceWith(filter_coll_final); 

                     var current_pagination = $('.collection_pagination');
                     var final_pagination = $(data).find('.collection_pagination');
                     current_pagination.replaceWith(final_pagination); 

           StampedFn.reloadUGC();
                  
                },
                error: function(xhr, status, error) {
                    console.error(error);
                }
            });
        }

$(document).ready(function(){
      $('.collection_filter__input').on('change', function() {        
       var selectedTags = $(this).val();     
        fetchFilteredProducts(selectedTags);        
      });
        

});